"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ArrayAsObjectCache = _interopRequireDefault(require("./ArrayAsObjectCache"));

var ScopesCache = new _ArrayAsObjectCache.default();

var _default = function _default(scopes) {
  return ScopesCache(scopes);
};

exports.default = _default;
module.exports = exports.default;